import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  subLoginHistory: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_SUB_LOGIN_HISTORY_SUCCESS:
      return { ...state, subLoginHistory: action.data };
    default:
      return state;
  }
};
